import script from "./ConfirmChangePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmChangePassword.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmChangePassword.vue?vue&type=style&index=0&id=12ebba71&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ebba71"]])

export default __exports__